import React, { useId } from 'react'
import PropTypes from 'prop-types'

const TriangleLargeIcon = React.forwardRef(function TriangleLargeIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C12.3589 4 12.6902 4.19229 12.8682 4.50386L20.8682 18.5039C21.0451 18.8134 21.0438 19.1936 20.8649 19.5019C20.686 19.8102 20.3565 20 20 20H4C3.64353 20 3.31401 19.8102 3.13509 19.5019C2.95617 19.1936 2.9549 18.8134 3.13176 18.5039L11.1318 4.50386C11.3098 4.19229 11.6411 4 12 4ZM5.72318 18H18.2768L12 7.01556L5.72318 18Z"
      ></path>
    </svg>
  )
})

TriangleLargeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

TriangleLargeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default TriangleLargeIcon
